import type {UpdateAuditDataCategories} from './UpdateAuditDataCategories';

export type UpdateAuditDataResponseItemBody = {
  id: string;
  state: UpdateAuditDataResponseItemBody.state;
  user: string | null;
  finishedAt: string | null;
  controlStructureId: string;
  vehicleId: string;
  categories: Array<UpdateAuditDataCategories>;
  inspectionType: UpdateAuditDataResponseItemBody.inspectionType | null;
};

export namespace UpdateAuditDataResponseItemBody {
  export enum state {
    FOR_CHECK = 'for_check',
    IN_PROGRESS = 'in_progress',
    FINISHED_AUDIT = 'finished_audit',
    TO_REVISION = 'to_revision',
    TO_FINISHING = 'to_finishing',
  }

  export enum inspectionType {
    VEHICLE_CONDITION = 'vehicleCondition',
    VALIDATION_INSPECTION = 'validationInspection',
    NON_VALIDATION_INSPECTION = 'nonValidationInspection',
  }
}
